import { createRouteMask } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';

/** The dashboard nav appends the active account as `account_id`; account-agnostic routes keep it out of the URL. */
const dropAccountId = ({ account_id, ...search }: { account_id?: string }) => search;

const ACCOUNT_AGNOSTIC_PATHS = [
  '/get-started',
  '/invitations',
  '/preferences',
  '/security',
  '/security/passkeys',
] as const;

export const routeMasks = [
  ...ACCOUNT_AGNOSTIC_PATHS.map((path) => createRouteMask({ routeTree, from: path, to: path, search: dropAccountId })),

  // The accounts list is an index route, so its `from` (the route's fullPath) keeps the trailing slash
  // that `to` (a link target) never has. Same route, two spellings — not a URL difference.
  createRouteMask({ routeTree, from: '/accounts/', to: '/accounts', search: dropAccountId }),
];
